'use es6';

import { defaultTheme } from './default';
import { halloween } from './halloween';
export default {
  halloween: halloween,
  defaultTheme: defaultTheme
};